<template>
  <b-modal
    v-model="_value"
    hide-header
    @ok="handleYes"
    @cancel="handleNo">
    <slot />
    <template #modal-footer="{ ok, cancel, hide }">
      <b-button
        size="sm"
        variant="light"
        @click="hide()">
        キャンセル
      </b-button>
      <b-button
        size="sm"
        @click="cancel()">
        いいえ
      </b-button>
      <b-button
        size="sm"
        variant="primary"
        @click="ok()">
        はい
      </b-button>
    </template>
  </b-modal>
</template>

<script>
/**
 * @description はい、いいえ、キャンセルの確認をするためのコンポーネント
 * 親コンポーネントから下記のイベントを渡すことができます
 * - yes はいボタン押下時の処理を渡す
 * - no いいえボタン押下時の処理を渡す
 * 
 * キャンセルボタンを押下するとただモーダルを閉じます
 */
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
  },
  methods: {
    handleYes() {
      this.$emit('yes')
    },
    handleNo() {
      this.$emit('no')
    }
  }
}
</script>

<style>

</style>